import validate from 'validate.js'

const constraints = {
  countryId: {
    presence: true
  }
}

export default (data) => {
  return validate(data, constraints)
}
